
// 插件路由
const groupBuy = () => import(/* webpackChunkName: "groupBuy" */ '~/addon/groupBuy/pages/groupBuy.vue')

const routes = [
	{ 
        path: '/groupBuy',
        component: groupBuy
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/groupBuy/router/index.js